import styled, { css } from 'styled-components';
import Image from 'next/image';
import { Breakpoints } from '../../../styled/constants';
import {
  GalleryActionButton,
  LeftArrow,
  RightArrow,
  Slide,
  SlideImage,
  Slider
} from '../../ui/GallerySlider/styled';

const sliderStyles = css`
  ${SlideImage} {
    object-fit: cover;
    object-position: center;
  }

  @media (min-width: ${Breakpoints.tablet}px) {
    ${Slider},
    ${Slide} {
      border-radius: 0;
      height: 330px;
    }
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    ${Slider} {
      border-radius: 14px;
    }

    ${Slider},
    ${Slide} {
      height: 520px;
    }
  }
`;

const sliderButtonsStyles = css`
  @media screen and (max-width: ${({ theme }) =>
      theme.smallDesktopBreakpoint}) {
    ${GalleryActionButton} {
      opacity: 0.6;
    }
  }

  ${RightArrow} {
    right: 15px;

    @media (min-width: ${Breakpoints.tablet}px) {
      right: 30px;
    }
  }

  ${LeftArrow} {
    left: 15px;

    @media (min-width: ${Breakpoints.tablet}px) {
      left: 30px;
    }
  }
`;

export const GalleryContainer = styled.div`
  position: relative;
  ${sliderStyles};
  ${sliderButtonsStyles};
`;

export const CollageContainer = styled.div`
  display: grid;
  grid-template-columns: 1.95fr 1.05fr;
  grid-template-rows: 1fr 1fr;
  gap: 10px;
  width: 100%;
  height: 520px;
`;

export const StyledImage = styled(Image)`
  object-fit: cover;
`;

export const CollageItem = styled.div<{ $position: number }>`
  position: relative;
  overflow: hidden;
  border-radius: 14px;

  ${({ $position }) =>
    $position === 0 &&
    `
      grid-column: 1 / 2;
      grid-row: 1 / 3;
    `};

  ${({ $position }) =>
    $position === 1 &&
    `
      grid-column: 2 / 3;
      grid-row: 1 / 2;
    `};

  ${({ $position }) =>
    $position === 2 &&
    `
      grid-column: 2 / 3;
      grid-row: 2 / 3;
    `};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;
export const infoViewsStyles = css`
  @media (min-width: ${Breakpoints.smallDesktop}px) {
    display: none;
  }
`;

export const GalleryWrapper = styled.div<{
  $isCollage: boolean;
  $shouldRenderCollage?: boolean;
}>`
  display: ${({ $isCollage }) => ($isCollage ? 'none' : 'block')};

  @media (min-width: ${Breakpoints.desktop}px) {
    display: ${({ $isCollage, $shouldRenderCollage }) =>
      $isCollage === $shouldRenderCollage ? 'block' : 'none'};
  }
`;
